import * as React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import Form from "./Form";

export default function ContactForm() {
  return (
    <Box
      sx={{
        width: "100%",
        padding:  {xs:"2rem 0 2rem", md:"10rem 0 10rem"},
        // backgroundColor: 'primary.dark',
        backgroundColor: "#cbe4de10",
    // padding: "2rem 0"
      }}
    >
      <Box
        sx={{
          height: "inherit",
          width: "inherit",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <Box id="lets_connect" sx={{ width: { sx: "90vw", md: "40vw", padding: "2rem" } }}>
          <Typography variant="h3" fontWeight={600} gutterBottom>
            Let's Connect
          </Typography>
          <Typography variant="h5" fontWeight={300} fontSize="1.2rem" gutterBottom>
          Get in touch and let us know how we can help. You can also reach out to us at care@apik.ai. Or call us at +919319737671
          </Typography>
        </Box>
        <Box sx={{ width: { xs: "90vw", md: "42vw" } }}>
          <Form />
        </Box>
      </Box>
    </Box>
  );
}
